import request from '@/config/axios'

export const createPay = (data: any) => {
  return request.post({
    url: '/pay/create',
    data
  })
}